<script setup>
import { reactive, ref, watch } from 'vue'
import ModalDialog from './ModalDialog.vue'
import { serializeCatalogItem, validateCatalogItem } from '../api/commerce'

const props = defineProps({ open: Boolean, item: { type: Object, default: null }, kind: { type: String, required: true }, saving: Boolean, error: { type: String, default: '' } })
const emit = defineEmits(['close', 'save'])
const form = reactive({ name: '', sku: '', unit: '', unit_price: '', initial_quantity: 0 })
const validationError = ref('')

watch(() => [props.open, props.item?.id, props.kind], ([open]) => {
  if (!open) return
  validationError.value = ''
  Object.assign(form, {
    name: props.item?.name || '', sku: props.item?.sku || '', unit: props.item?.unit || (props.kind === 'product' ? 'шт.' : 'усл.'),
    unit_price: props.item?.unit_price ?? '', initial_quantity: 0,
  })
})

function submit() {
  if (props.saving) return
  validationError.value = validateCatalogItem(form, props.kind, Boolean(props.item))
  if (!validationError.value) emit('save', serializeCatalogItem(form, props.kind, Boolean(props.item)))
}
</script>

<template>
  <ModalDialog :open="open" :title="item ? 'Редактировать позицию' : kind === 'product' ? 'Новый товар' : 'Новая услуга'" eyebrow="Справочник" @close="!saving && emit('close')">
    <form class="dialog-form" @submit.prevent="submit">
      <label class="field"><span>Название <b aria-hidden="true">*</b></span><input v-model="form.name" maxlength="160" required autofocus /></label>
      <div class="form-grid form-grid--2">
        <label class="field"><span>Артикул</span><input v-model="form.sku" maxlength="80" /></label>
        <label class="field"><span>Единица измерения</span><input v-model="form.unit" maxlength="32" required /></label>
      </div>
      <label class="field"><span>Цена, ₽ <b aria-hidden="true">*</b></span><input v-model="form.unit_price" type="text" inputmode="decimal" required placeholder="0,00" /></label>
      <label v-if="kind === 'product' && !item" class="field"><span>Начальный остаток</span><input v-model="form.initial_quantity" type="number" min="0" max="2147483647" step="1" required /></label>
      <p class="catalog-hint">Изменение справочника не меняет название и цену уже проведённых продаж. Остатки меняются только складской операцией.</p>
      <p v-if="validationError || error" class="form-error" role="alert">{{ validationError || error }}</p>
      <footer class="modal-actions">
        <button class="button button--ghost" type="button" :disabled="saving" @click="emit('close')">Отмена</button>
        <button class="button button--primary" type="submit" :disabled="saving">{{ saving ? 'Сохраняем…' : 'Сохранить' }}</button>
      </footer>
    </form>
  </ModalDialog>
</template>

<style scoped>.catalog-hint { color: var(--muted); font-size: .76rem; line-height: 1.5; }</style>
